export const loginBg =
	"https://assets.nflxext.com/ffe/siteui/vlv3/2e07bc25-8b8f-4531-8e1f-7e5e33938793/e4b3c14a-684b-4fc4-b14f-2b486a4e9f4e/IN-en-20240219-popsignuptwoweeks-perspective_alpha_website_large.jpg";
export const netflixLogo =
	"https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";

export const userIcon =
	"https://occ-0-2186-2164.1.nflxso.net/dnm/api/v6/vN7bi_My87NPKvsBoib006Llxzg/AAAABeuqjuQsRgqEDlibtJTI5BMf8IxhLlLOeIT6xI4TL57mqv7XHja43gx02S8pZVe8JNGRQXjnrUk1VcsTXqi83tFKPI6OR3k.png?r=bd7";

export const API_OPTIONS = {
	method: "GET",
	headers: {
		accept: "application/json",
		Authorization: "Bearer " + process.env.REACT_APP_TMDB_KEY,
	},
};

export const POSTER_CDN = "https://image.tmdb.org/t/p/w300/";

export const OPENAI_KEY = process.env.REACT_APP_OPENAI_KEY;

export const LANGUAGES = [
	{
		name: "English",
		placeholderText: "What do you want to watch today?",
		searchText: "Search",
	},
	{
		name: "Hindi",
		placeholderText: "आज आप क्या देखना चाहते हैं?",
		searchText: "खोज",
	},
	{
		name: "Spanish",
		placeholderText: "¿Qué quieres ver hoy?",
		searchText: "buscar",
	},
	{
		name: "Kannada",
		placeholderText: "ನೀವು ಇಂದು ಏನನ್ನು ವೀಕ್ಷಿಸಲು ಬಯಸುತ್ತೀರಿ?",
		searchText: "ಹುಡುಕಿ",
	},
];
